/**
 * WC View
 */

define(function(require, exports, module) {
    'use strict';

    var BaseReplacerView = require('common/base.replacer.view');

    module.exports = BaseReplacerView.extend({

        className: 'wc-replacer',

        render: function(wcId) {
            this.loadContent(wcId).done((content) => this.$el.html(this.parseReplacers(content)));

            return this;
        }

    }, {
        nameOfReplacers: [
            'WC'
        ]
    });
});